import { addMethod, string, object, boolean } from 'yup';
import Api from 'api';
import { storage } from 'store';
import { getCachedDnsCheck, setCachedDnsCheck } from './services';

export const basicEmailValidation = value => {
  // RFC 3696-compliant email regex (practical version)
  // - local part: up to 64 chars, domain: up to 255 chars, total: up to 254 chars
  // - no consecutive dots, no leading/trailing dot in local part
  const emailRegex =
    /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_{|}~`\-‘]+(\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~`\-‘]+)*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

  if (!emailRegex.test(value)) {
    storage.addItem('isEmailCheckedSuccessful', false);
    return false;
  }

  return true;
};

const emailDnsValidation = async email => {
  const cachedResult = getCachedDnsCheck(email);

  if (cachedResult !== undefined) {
    storage.addItem('isEmailCheckedSuccessful', cachedResult);
    return cachedResult;
  }

  try {
    storage.addItem('isEmailCheckLoading', true);
    storage.addItem('isEmailCheckedSuccessful', false);

    const dnsCheck = await Api.getDnsCheck(email);

    const checkStatus = dnsCheck?.status || false;
    setCachedDnsCheck(email, checkStatus);
    storage.addItem('isEmailCheckedSuccessful', checkStatus);

    return checkStatus;
  } catch (error) {
    storage.addItem('isEmailCheckedSuccessful', false);
    setCachedDnsCheck(email, false);

    return false;
  } finally {
    storage.addItem('isEmailCheckLoading', false);
  }
};

export const emailValidation = async value => {
  const isBasicValid = basicEmailValidation(value);

  if (isBasicValid) {
    return await emailDnsValidation(value);
  }

  return false;
};

const phoneValidation = value => {
  if (!value) {
    return false;
  }

  return value.length >= 5 && value.length <= 18;
};

addMethod(string, 'checkPhone', function (message) {
  return this.test('checkPhone', message, function (value) {
    return phoneValidation(value);
  });
});

addMethod(string, 'checkEmail', function (message) {
  return this.test('checkEmail', message, async function (value) {
    return emailValidation(value);
  });
});

const corporateEmail = messages => {
  return string().required(messages.required).checkEmail(messages.required);
};

const phone = messages => {
  const message = 'Пожалуйста, введите номер телефона';

  return string()
    .required(messages || message)
    .checkPhone(messages || message);
};

export const corporateFormSchema = messages => {
  return object().shape(
    {
      name: string().required(messages.name),
      email: corporateEmail(messages.email),
      phone: phone(messages.phone),
      message: string().required(messages.message),
      NDA: boolean(),
    },
    ['email', 'phone'],
  );
};
